import * as React from 'react';
import styled from 'styled-components';
import { position } from 'styled-system';
import { themeGet } from '../../theme/utils';
import {
  ArrowProps,
  POPOVER_BACKGROUND_COLOR,
  POPOVER_BORDER_COLOR,
  arrowPosition,
  arrowInner,
  arrowOuter,
  POPOVER_ARROW_BORDER_WIDTH_OUTER,
  POPOVER_ARROW_BORDER_WIDTH_INNER,
  popoverPositionMap,
  PopoverPosition,
  PopoverPositionProps,
} from './InputPopoverConfig';

export const InputPopoverStyled = styled.div<PopoverPositionProps & ArrowProps>`
  position: absolute;
  background-color: ${themeGet.colors(POPOVER_BACKGROUND_COLOR)};
  width: 100%;
  padding: ${themeGet.space(2)};
  box-shadow: 0px 8px 8px -5px rgba(43, 18, 2, 0.3);
  border: 1px solid ${themeGet.colors(POPOVER_BORDER_COLOR)};
  border-radius: 6px;
  ${position}
  transform: ${(props) => props.transform};
  &:after,
  &:before {
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    ${arrowPosition}
  }
  &:after {
    border-width: ${POPOVER_ARROW_BORDER_WIDTH_INNER};
    ${arrowInner}
  }

  &:before {
    border-width: ${POPOVER_ARROW_BORDER_WIDTH_OUTER};
    ${arrowOuter}
  }
`;

export const InputPopover: React.FC<{ position: PopoverPosition }> = ({ position, children }) => {
  const positionData = popoverPositionMap[position];
  return (
    <InputPopoverStyled {...positionData.popoverPosition} {...positionData.arrowProps}>
      {children}
    </InputPopoverStyled>
  );
};
